import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-case-dairy-form',
  templateUrl: './case-dairy-form.component.html',
  styleUrls: ['./case-dairy-form.component.css']
})
export class CaseDairyFormComponent implements OnInit {

  title = "Case Diary";
  Fir_id: any;
  FirDetails: any = {};
  CaseDiary: any = {};
  fileToUpload: File = null;
  formSubmitted: boolean;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.route.params.subscribe(params =>
      this.Fir_id = params['Fir_id']
    );
    if (this.Fir_id != null)
      this.GetFirForTheId(this.Fir_id);
  }

  GetFirForTheId(Fir_id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetFirForTheId(Fir_id)
      .subscribe(
        (data: any) => {
          this.FirDetails = data;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  FileInput(file: FileList) {

    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;


    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        // this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          let i: any = document.getElementById('CD_Doc_Upload');
          i.value = "";
          if (error.status == 400) {
            // this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('CD_Doc_Upload');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }

  getFeasibilityPDFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('CD_Doc_Upload');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  onSubmit(Fir_id: any, form: NgForm) {
    debugger
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.CD_Doc_Upload = this.getFeasibilityPDFUrl();
      this.userService.CreateCaseDiary(Fir_id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetFirForTheId(Fir_id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Saved Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  DeleteCaseDiary(CD_Id,CD_Fir_Id) {
    debugger
    if (CD_Id != null) {
      swal({
        title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.DeleteCaseDiary(CD_Id)
            .subscribe(
              (data) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.GetFirForTheId(CD_Fir_Id);
                swal('', 'Deleted Successfully!', 'success');
                
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                this.errorHandler.HandlerError(error);
              });
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/case-dairys/case-dairy/case-dairy-form/case-dairy-form.component.ts